
import * as types from '../constants/ActionTypes';
import * as consts from '../constants';
import { assign } from 'lodash';

const initialState = consts.applicationModes.INDEX;

export default function (state = initialState, action) {
  switch (action.type) {
    case types.SET_APP_MODE:
      return action.mode;
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/reducers/applicationMode.js
 **/